export const font:any = {
    body: 'Oswald'
};
